<template>
  <v-card class="vehicle-card" :class="!expanded && 'bg0'">
    <!-- header -->
    <div class="p-relative header">
      <ImageCarousel v-if="showCarousel" :images="vehicle.moreImages" />
      <v-img v-else :src="require(`@/assets/img/vehicles/${vehicle.image}`)" lazy-src="@/assets/img/placeholder.png">
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0 white"
            align="center"
            justify="center"
          >
            <v-progress-circular indeterminate color="blue"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <div class="p-absolute col-flex cover-text white--text text-left">
        <span class="size-24 weight6 lh-29 text-uppercase">{{vehicle.name}}</span>
        <span class="size-24 lh-29 weight3">{{vehicle.model}}</span>
      </div>
    </div>
    <!-- body -->
    <v-card-text class="pt-6 pb-8 p-relative white">

      <!-- SLOTS FOR SWIPE -->
      <slot name="swipeRight"></slot>
      <slot name="swipeLeft"></slot>

      <!-- Actions -->
      <div class="mb-5 vehicle-actions" v-if="showActions">
        <v-layout align-center justify-center>
          <v-btn
            class="button text-capitalize white--text size-16 font-weight-bold mx-2"
            color="#228B22"
            @click="$router.push('/order/' + vehicle.id)"
          >
            Bestellen
          </v-btn>
          <v-btn
            class="button text-capitalize size-16 font-weight-bold mx-2"
            @click="onComparisonClick(vehicle.id)"
            :disabled="toCompare.indexOf(vehicle.id) !== -1"
          >
            Vergleichen
          </v-btn>
        </v-layout>
      </div>

      <div class="row-flex align-center">
        <span class="size-20 mr-auto align-self-end">Daten</span>
        <v-btn class="add-btn" @click="expanded = !expanded">
          <v-icon>{{expanded ? 'mdi-minus' : 'mdi-plus'}}</v-icon>
        </v-btn>
      </div>
      <v-divider class="my-3"></v-divider>
      <div class="size-18 black--text details mt-8">
        <div class="row-flex justify-space-between">
          <span>Preis:</span>
          <span>{{vehicle.ourPrice | numberFormat}} €</span>
        </div>
        <div class="row-flex justify-space-between">
          <span>Reichweite:</span>
          <span>{{vehicle.reach}} km</span>
        </div>
        <div class="row-flex justify-space-between">
          <span>Geschwindigkeit:</span>
          <span>{{vehicle.speed}} km/h</span>
        </div>
        <div class="no-margin-bottom row-flex justify-space-between">
          <span>Modell:</span>
          <span>{{vehicle.modell}}</span>
        </div>
        <v-expand-transition>
            <div class="mb-0" v-if="expanded">
              <div class="hidden-row row-flex justify-space-between padding-top-20">
                <span>Beschleunigung:</span>
                <span>{{(vehicle.acceleration + '').replace('.', ',')}} s</span>
              </div>
              <div class="hidden-row row-flex justify-space-between">
                <span>Verbrauch:</span>
                <span>{{(vehicle.motor + '').replace('.', ',')}} kWh</span>
              </div>
              <div class="hidden-row row-flex justify-space-between">
                <span>Leistung:</span>
                <span>{{vehicle.range}} kW</span>
              </div>
              <div class="hidden-row row-flex justify-space-between">
                <span>Sitzplätze:</span>
                <span>{{vehicle.seats}}</span>
              </div>
              <div class="row-flex justify-space-between">
                <span>Laderaum:</span>
                <span>{{vehicle.loading}} l</span>
              </div>
            </div>
        </v-expand-transition>
        <span :id="'ex-'+vehicle.id"></span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ImageCarousel from  './ImageCarousel'

export default {
  name: 'vehicle-card',
  props: ['showActions', 'showCarousel', 'vehicle'],
  components: {
    ImageCarousel
  },
  data: () => ({
    expanded: false
  }),
  computed: {
    toCompare: function() {
      return this.$store.state.toCompare;
    } 
  },
  methods: {
    onComparisonClick(id) {
      if(this.toCompare.length == 1)
        this.$router.push('comparison');
      this.$store.commit("ADD_TO_COMPARISON", {id, toast: this.$toasted});
    }
  },
  watch: {
    'expanded': function(val) {
      if(val)
        setTimeout(() => {
          document.querySelector('#ex-'+this.vehicle.id).scrollIntoView({
            block: 'nearest'
          });
        }, 255)
    }
  },
  filters: {
    numberFormat(val) {
      return Number(val).toLocaleString('DE');
    }
  }
}
</script>

<style lang="scss">
.vehicle-card {
  border-radius: 14px !important;
  margin-bottom: 10px;
  overflow: hidden;

  .header {
    height: 262.66px;
    max-height: 262.66px;
    overflow: hidden;
    transition: all 0.25s;
  }
  .v-image {
    border-radius: unset !important;
    height: 262.66px;
  }
  @media only screen and (max-width: 360px) {
    .header {
      height: 220px;
      max-height: 220px;
      overflow: hidden;
      transition: all 0.25s;
    }
    .v-image {
      border-radius: unset !important;
      height: 220px;
    } 
  }
  .cover-text {
    background-color: rgba(0, 0, 0, 0.51);
    bottom: 0px;
    width: 100%;
    padding: 10px 18px;
  }
  .add-btn {
    height: 50px !important;
    width: 50px !important;
    min-width: 0px !important;
    padding: 0 !important;
    border-radius: 14px;
    background: #E2E7EA;
  }
  .details {

    & > div, .hidden-row {
      margin-bottom: 20px;
    }
    .no-margin-bottom {
      margin-bottom: 0;
    }
    .margin-top-20 {
      margin-top: 20px;
    }
    .padding-top-20 {
      padding-top: 20px;
    }
  }
  .vehicle-actions {
    .button {
      height: 50px;
      width: 50%;
      border-radius: 25px;
    }
  }
}
</style>